<template>
  <div v-if="experience">
    <!-- PROFILE HEADER -->
    <div class="profile-header">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img :src="coverSrc" role="presentation" class="responsive block" alt="" />
        </div>
      </div>

      <breadcrumb class="mt-5" :breadcrumbs="breadcrumb" />
      <heading size="h1" style-size="h3" class="mt-3">{{ experience.vje.name }}</heading>
    </div>
    <vs-tabs-link
      :experience="experience"
      :tab_contents="tab_contents"
      @update-activity="updateActivity"
    ></vs-tabs-link>
  </div>
  <no-active-vje v-else></no-active-vje>
</template>

<script>
import store from '@/store/store';
import NoActiveVje from '@/components/UI/students/NoActiveVje';
import Breadcrumb from '../../../../components/UI/Breadcrumb';
import VsTabsLink from '@/components/TabsLink.vue';

export default {
  components: { VsTabsLink, Breadcrumb, NoActiveVje },
  computed: {
    breadcrumb() {
      const route_name = this.$route.name;
      let current_page = [];
      switch (route_name) {
        case 'we-learning_and_resources':
          current_page = [
            {
              title: 'Learning & Resources',
              status: 'active',
            },
          ];
          break;

        case 'we-activities':
          current_page = [
            {
              title: 'Activities',
              status: 'active',
            },
          ];
          break;

        case 'we-introduction':
          current_page = [
            {
              title: 'Introduction',
              status: 'active',
            },
          ];
          break;

        case 'we-tour_and_induction':
          current_page = [
            {
              title: 'Tour & Induction',
              status: 'active',
            },
          ];
          break;

        case 'activity-student':
          current_page = [
            {
              title: 'Activities',
              url: `/student/work-experience/${this.$route.params.id}/activities`,
            },
            {
              title: this.activity_title,
              status: 'active',
            },
          ];
      }

      return [
        {
          title: 'Home',
          url: `/${this.loginType}/dashboard`,
        },
        {
          title: 'Virtual Experiences',
          url: `/${this.loginType}/available-experiences`,
        },
        {
          title: `Experience - ${this.experience.vje.name}`,
          url: `/${this.loginType}/work-experience/${this.$route.params.id}/`,
        },
        ...current_page,
      ];
    },
    experience() {
      if (this.loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    coverSrc() {
      return require('@/assets/images/experiences/' +
        this.experience.vje.folder_name.toLowerCase() +
        '/cover_photo.jpg');
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
    all_tab_contents() {
      let tab_contents = [];

      if (this.experience.type === 1) {
        if (this.experience.vje.is_external) {
          tab_contents = [
            {
              link: '/student/work-experience/' + this.$route.params.id + '/tour_and_induction',
              name: 'Get Started',
            },
            {
              link: '/student/work-experience/' + this.$route.params.id + '/activities',
              name: 'Certificate',
            },
          ];
        } else {
          tab_contents = [
            {
              link: '/student/work-experience/' + this.$route.params.id + '/tour_and_induction',
              name: 'Tour & Induction',
            },
            {
              link: '/student/work-experience/' + this.$route.params.id + '/introduction',
              name: 'Introduction',
            },
            {
              link: '/student/work-experience/' + this.$route.params.id + '/learning_and_resources',
              name: 'Learning & Resources',
            },
            {
              link: '/student/work-experience/' + this.$route.params.id + '/activities',
              name: 'Activities',
            },
            {
              link: '/student/work-experience/' + this.$route.params.id + '/projects',
              name: 'Projects',
              hidden: true,
            },
          ];
        }
        if (this.experience.active === 0) {
          if (
            this.loginType === 'student' &&
            typeof this.experience.postwork !== 'undefined' &&
            this.experience.postwork !== null &&
            this.experience.postwork.certificate_status === 0
          ) {
            tab_contents.push({
              link: '/student/work-experience/' + this.$route.params.id + '/reflection/edit',
              name: 'Reflection',
            });
          } else {
            tab_contents.push({
              link: '/student/work-experience/' + this.$route.params.id + '/reflection',
              name: 'Reflection',
            });
          }
        }
        if (
          this.loginType === 'student' &&
          typeof this.experience.postwork !== 'undefined' &&
          this.experience.postwork !== null &&
          this.experience.postwork.certificate_status === 3
        ) {
          tab_contents.push({
            link: '/student/work-experience/' + this.$route.params.id + '/certificate',
            name: 'Certificate',
          });
        }
      } else {
        tab_contents.push(
          {
            link: '/student/work-experience/' + this.$route.params.id + '/experience-info',
            name: 'Experience Info',
          },
          {
            link: '/student/work-experience/' + this.$route.params.id + '/reflection',
            name: 'Reflection',
          },
          {
            link: '/student/work-experience/' + this.$route.params.id + '/thankyou_letter',
            name: 'Thankyou Letter',
          },
        );
      }
      return tab_contents;
    },
    tab_contents() {
      return this.all_tab_contents.filter((item) => !item.hidden);
    },
  },
  methods: {
    updateActivity(activity) {
      this.activity_title = activity;
    },
  },
  data() {
    return {
      loginType: localStorage.getItem('login_type'),
      tab_value: this.$route.path,
      activity_title: null,
    };
  },
  watch: {
    '$route.name'(value) {
      if (value === 'we-activities') {
        this.activity_title = null;
      }
    },
  },
};
</script>
